// PerformanceModal.jsx
import React from "react";
import classes from "./performanceModal.module.css";
import { motion, useScroll, useTransform } from "framer-motion";

import { AnimatePresence } from "framer-motion";
import { useDispatch } from "react-redux";
import {
  castVote,
  fetchActiveContests,
  fetchParticipantsByCategory,
} from "../../../redux/slices/andArenaSlice";
import { getYoutubeVideoId } from "../../../utils";

const categoryToCategoryMap = (categoryFromFrontEnd) => {
  switch (categoryFromFrontEnd) {
    case "singing":
      return "singer";
    case "video-editing":
      return "video_editor";
    case "photography":
      return "photography";
    case "magician":
      return "magician";
    case "dancing":
      return "dancer";
    default:
      return "singer";
  }
};

const PerformanceModal = ({
  artist,
  onClose,
  activeCategory,
  onVoteSuccess,
}) => {
  const dispatch = useDispatch();

  // Prevent clicks inside the modal from closing it
  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  const handleVote = async () => {
    try {
      const res = await dispatch(
        castVote({
          username: artist?.participant?.username,
          contest_id: artist?.contestInfo?.contest_id,
        })
      );

      // Call the success callback to refresh data in parent component
      if (res && onVoteSuccess) {
        onVoteSuccess();
      }
    } catch (error) {
      console.error("Error casting vote:", error);
    }
  };

  return (
    <div className={classes.modalOverlay} onClick={onClose}>
      <div className={classes.modalContent} onClick={handleModalClick}>
        <div className={classes.modalHeader}>
          <h2>
            {artist?.participant?.username}'s Performance -{" "}
            {artist?.contestInfo?.title}
          </h2>
          <button className={classes.closeButton} onClick={onClose}>
            ×
          </button>
        </div>

        <div className={classes.modalBody}>
          <div className={classes.videoContainer}>
            <AnimatePresence mode="wait">
              <motion.div
                className={classes.videoFrame}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
              >
                {true ? (
                  <div className={classes.videoContainer}>
                    {artist?.contestInfo?.youtube_url?.endsWith(".jpeg") ? (
                      <img
                        src={artist.contestInfo.youtube_url}
                        alt={`Image of ${artist?.participant?.username}`}
                        className={`${classes.videoIframe} ${classes.containImage}`}
                      />
                    ) : (
                      <iframe
                        src={
                          artist?.contestInfo?.youtube_url
                            ? `https://www.youtube.com/embed/${getYoutubeVideoId(
                                artist.contestInfo.youtube_url
                              )}`
                            : ""
                        }
                        title={`Video of ${artist?.participant?.username}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className={classes.videoIframe}
                      ></iframe>
                    )}
                  </div>
                ) : (
                  <div className={classes.invalidVideo}>
                    <p>Invalid YouTube URL</p>
                  </div>
                )}
              </motion.div>
            </AnimatePresence>
          </div>

          <div className={classes.performanceDetails}>
            <h3>Description</h3>
            <p>{artist?.contestInfo?.description}</p>

            <div className={classes.performanceStats}>
              <div className={classes.statItem}>
                <span className={classes.statLabel}>Current Votes:</span>
                <span className={classes.statValue}>
                  {artist?.contestInfo?.votes}
                </span>
              </div>
              {/* <div className={classes.statItem}>
                <span className={classes.statLabel}>Ranking:</span>
                <span className={classes.statValue}>#3 in category</span>
              </div> */}
            </div>

            <div className={classes.modalActions}>
              <button className={classes.modalVoteButton} onClick={handleVote}>
                Cast Vote
              </button>
              <button className={classes.modalCloseButton} onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerformanceModal;
